/**
 * @fileoverview Application entry point
 * @module main
 */
import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { createI18nInstance, initializeLocale } from './plugins/i18n'
import { initFirebase } from './plugins/firebase'
import { installGlobalErrorHandlers } from './composables/useErrorLogging'
import { consumeAuthHandoffToken } from './utils/authHandoff'

// Initialize Firebase
initFirebase()

// Create app
const app = createApp(App)

// Create i18n instance
const i18n = createI18nInstance()

// Install global error handlers
installGlobalErrorHandlers(app)

// Install plugins
app.use(createPinia())
app.use(router)
app.use(vuetify)
app.use(i18n)

// Initialize app: consume auth handoff token if present, then initialize locale and mount
async function initApp() {
  // Check for and consume cross-domain auth handoff token
  await consumeAuthHandoffToken()

  // Initialize preferred locale before mounting to prevent i18n race condition
  await initializeLocale(i18n)

  app.mount('#app')
}

initApp()
